var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb20 relative"},[_c('div',{staticStyle:{"height":"170px"},attrs:{"id":"amap"}}),(_vm.showTime&&_vm.traceList.length)?_c('div',{staticClass:"absolute time fs12 flex aic jcc"},[_vm._v("\n        "+_vm._s(_vm.distance)+"("+_vm._s(_vm.time)+")\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }